<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent prueba git
========================================================================================== -->

<template>
	<div id="page-user-view">
		<vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
			<span>{{ $t("UserRecordWithId") + ":" + $route.params.userId + " " + $t("NotFound") }}. </span>
			<span>
				<span>Check </span
				><router-link :to="{name: 'page-user-list'}" class="text-inherit underline">All Users</router-link>
			</span>
		</vs-alert>
		<div id="user-data" v-if="resource_data">
			<vx-card :title="$t('Information')">
				<div class="vx-row">
					<!-- Avatar Col -->
					<div class="vx-col" id="avatar-col">
						<div class="img-container mb-4">
							<img :src="avatar" class="rounded w-full" alt="" />
						</div>
					</div>

					<!-- Information - Col 1 -->
					<div class="vx-col flex-1" id="account-info-col-1">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">
									{{ $t("Username") }}
								</td>
								<td>{{ resource_data.username }}</td>
							</tr>
							<tr>
								<td class="font-semibold">{{ $t("Name") }}</td>
								<td>
									{{ resource_data.name }}
									{{ resource_data.lastname }}
								</td>
							</tr>
							<tr>
								<td class="font-semibold">
									{{ $t("MODULE_SOURCE.id") }}
								</td>
								<td>{{ resource_data.identification }}</td>
							</tr>
							<tr>
								<td class="font-semibold">
									{{ $t("Company") }}
								</td>
								<td>{{ company_name }}</td>
							</tr>
						</table>
					</div>

					<!-- Information - Col 2 -->
					<div class="vx-col flex-1" id="account-info-col-2">
						<table>
							<caption></caption>
							<thead>
								<tr>
									<th scope="col"></th>
								</tr>
							</thead>
							<tr>
								<td class="font-semibold">{{ $t("Email") }}</td>
								<td>{{ resource_data.email }}</td>
							</tr>
							<tr>
								<td class="font-semibold">
									{{ $t("Status.Title") }}
								</td>
								<td>{{ status }}</td>
							</tr>
							<tr>
								<td class="font-semibold">
									{{ $t("MODULE_ROLE.Role") }}
								</td>
								<td>{{ role_name }}</td>
							</tr>
							<tr>
								<td class="font-semibold">
									{{ $t("AddedOn") }}
								</td>
								<td>{{ addedOn }}</td>
							</tr>
						</table>
					</div>
					<!-- /Information - Col 2 -->
					<div class="vx-col w-full flex justify-end mt-5" id="account-manage-buttons">
						<vs-button
							v-if="resourceUpdatePermission"
							type="border"
							color="success"
							icon-pack="feather"
							icon="icon-edit"
							class="mr-4"
							:title="windowWidth > 620 ? null : $t('Crud.Update')"
							:size="iconSize"
							:to="{
								name: 'app-resource-edit',
								params: {id: $route.params.userId},
							}"
							>{{ windowWidth > 620 ? $t("Crud.Update") : null }}</vs-button
						>
						<vs-button
							v-if="resourceDeletePermission"
							type="border"
							color="danger"
							icon-pack="feather"
							icon="icon-trash"
							:title="windowWidth > 620 ? null : $t('Crud.Delete')"
							:size="iconSize"
							@click="confirmDeleteRecord"
							>{{ windowWidth > 620 ? $t("Crud.Delete") : null }}</vs-button
						>
						<vs-button
							class="ml-4"
							type="border"
							color="primary"
							icon-pack="feather"
							icon="icon-list"
							:title="windowWidth > 620 ? null : $t('Crud.List') + ' ' + $t('Resources')"
							:size="iconSize"
							:to="{name: 'app-resources-list'}"
							>{{ windowWidth > 620 ? $t("Crud.List") + " " + $t("User") : null }}</vs-button
						>
					</div>
				</div>
				<vs-divider class="mt-base mb-base"></vs-divider>
				<template lang="html">
					<vs-tabs>
						<vs-tab :label="$t('AdditionalFields') | capitalize" icon-pack="feather" icon="icon-file-plus">
							<vx-card no-shadow card-border class="mb-base mt-base">
								<table
									v-if="
										resource_data.additional_info &&
										Object.keys(resource_data.additional_info).length > 0
									"
								>
									<caption></caption>
									<tr v-for="(value, label) in resource_data['additional_info']" :key="label">
										<th class="font-semibold" style="font-size: 14px">{{ label | capitalize }}</th>
										<td>{{ value }}</td>
									</tr>
								</table>
								<vs-alert v-else active class="mb-5" color="primary">
									<span>
										{{ $t("NotAdditionalFields") }}
									</span>
								</vs-alert>
							</vx-card>
						</vs-tab>
					</vs-tabs>
				</template>
			</vx-card>
		</div>
	</div>
</template>

<script>
import moduleResource from "@/store/resource/moduleResource.js";
import VxCard from "../vx-card/VxCard.vue";
import DateUtils from "@/helpers/DateUtils.js";
import AssignedCapacityList from "@/components/capacity/AssignedCapacityList.vue";

export default {
	components: {VxCard, AssignedCapacityList},
	data() {
		return {
			resource_data: null,
			user_not_found: false,
			avatar: require("@/assets/images/portrait/small/user-avatar.png"),
			company_name: "",
			status: "",
			role_name: "",
		};
	},
	computed: {
		userAddress() {
			let str = "";
			for (const field in this.resource_data.location) {
				str += `${field} `;
			}
			return str;
		},
		addedOn() {
			return DateUtils.stringToDate(this.resource_data.added_on);
		},
		resourceUpdatePermission() {
			return this.$store.getters.checkPermission("RESOURCES_U");
		},
		resourceDeletePermission() {
			return this.$store.getters.checkPermission("RESOURCES_D");
		},
		capacityIds() {
			return this.resource_data["capacities"] && this.resource_data["capacities"] !== null
				? this.resource_data["capacities"].map(({capacity_id}) => capacity_id)
				: [];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	watch: {
		"$route.params.userId": {
			handler: function (search) {
				this.consultResourceGlobal();
			},
		},
	},
	methods: {
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("ResourceModule.Messages.Delete") + ` "${this.resource_data.username}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$vs.loading();
			this.$store
				.dispatch("moduleResource/removeResource", this.$route.params.userId)
				.then((res) => {
					this.$vs.loading.close();
					this.$router.push("/apps/resource/resources-list");
					this.$vs.notify({
						color: "success",
						title: this.$t("ResourceModule.Messages.TitleDeleted"),
						text: this.$t("ResourceModule.Messages.Deleted"),
					});
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("ResourceModule.Table.Errors.Delete"),
					});
					console.error(err);
				});
		},
		consultResourceGlobal() {
			const userId = parseInt(this.$route.params.userId);
			const dataFilter = {
				ids: [userId],
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleResource/fetchResourceById", userId)
				.then((res) => {
					if (res.length > 1) {
						res = res[0];
					}
					this.resource_data = res.data;
					this.$store
						.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
						.then((res) => {
							if (res.length > 1) {
								res = res[0];
							}
							this.company_name = res.data.records[0].company_name;
							this.status = res.data.records[0].status;
							this.role_name = res.data.records[0].role_name;
							this.$vs.loading.close();
						})
						.catch((err) => {
							console.error(err);
							this.$vs.loading.close();
							this.$vs.notify({
								color: "danger",
								title: this.$t("Error"),
								text: this.$t("ResourceModule.Table.Errors.ConsultResource"),
							});
						});
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					this.$router.push("/apps/resource/resources-list");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("ResourceModule.UserNotFound"),
					});
				});
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	mounted() {
		this.consultResourceGlobal();
	},
};
</script>

<style lang="scss">
#avatar-col {
	width: 10rem;
}

.img-container {
	width: 100%;
	height: 10rem;
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
}

#page-user-view {
	table {
		td {
			vertical-align: top;
			min-width: 140px;
			padding-bottom: 0.8rem;
			word-break: break-all;
		}

		&:not(.permissions-table) {
			td {
				@media screen and (max-width: 370px) {
					display: block;
				}
			}
		}
	}
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
	only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
